import path from "path";

import { ChainableValueProducer } from "../Commons/TasksCore/ChainableValueProducer";
import { Observe } from "../Commons/TasksCore/Observe";

export async function createEngineWebpackConfigTask(engineDirectory: string): Promise<ChainableValueProducer<string>> {
    return Observe.file(path.join(engineDirectory, "webpack.config.js"));
}

export async function createClientWebpackConfigTask(engineDirectory: string): Promise<ChainableValueProducer<string>> {
    return Observe.file(path.join(engineDirectory, "clientjs.webpack.config.js"));
}

export async function createClientViteConfigTask(engineDirectory: string): Promise<ChainableValueProducer<string>> {
    return Observe.file(path.join(engineDirectory, "Widgets", "CandyWidget", "vite", "common.ts"));
}
